<template>
    <div>
        <v-app-bar
            height="84"
            elevation="0"
            color="transparent"
            style="position: fixed; z-index: 1"
        >
            <v-toolbar-title>
                <v-img
                    :src="require('@/assets/schooney_logo.png')"
                    class="my-3"
                    contain
                />
            </v-toolbar-title>

            <v-spacer></v-spacer>

            <v-btn icon @click="changeLocale('th','localThaiBtn','localEngBtn')">
                <a id="localThaiBtn" class="prompt-16" style="font-weight: 400; color: #ffffff"
                    >ไทย</a
                >
            </v-btn>
            <div style="height: 20px; display: flex; align-items: center;">
                <v-divider
                    vertical
                    color="white"
                    style="border: 0.5px solid #ffffff"
                ></v-divider>
            </div>
            <v-btn icon @click="changeLocale('en','localEngBtn','localThaiBtn')">
                <a id="localEngBtn" class="prompt-16" style="font-weight: 400; color: #ffffff"
                    >EN</a
                >
            </v-btn>
        </v-app-bar>
    </div>
</template>

<script>
import i18n from "@/i18n";

export default {
    name: "NavbarTransparent",
    methods: {
        changeLocale(locale,emUnderline,emNotunderline) {
            document.getElementById(emUnderline).style.textDecoration = 'underline'
            document.getElementById(emNotunderline).style.textDecoration = 'none'
            localStorage.setItem("language", locale);
            i18n.locale = locale;
        },
    },
    mounted() {
        if (
            localStorage.getItem("language") == null ||
            localStorage.getItem("language") == undefined
        ) {
            localStorage.setItem("language", "th");
        }

        if(localStorage.getItem("language")==='th'){
            this.changeLocale(localStorage.getItem("language"),'localThaiBtn','localEngBtn');
        }
        else{
            this.changeLocale(localStorage.getItem("language"),'localEngBtn','localThaiBtn');
        }
            
    },
};
</script>
